import React, { useState } from "react";
import { months } from "../../Utils/months";
import { Field, FieldArray } from "redux-form";
import {
    renderDollar,
    renderFieldDisabled,
    renderDollarDisabled,
    renderNumberPercentage,
} from "../../Utils/renderField/renderField";
import {
    positiveNumberField,
    positivePercentageField,
} from "../../../../utility/getErrors";

const handleChange = (change, dataForm) => {
    const ivaRate = 1.12; // 12% IVA
    if (
        dataForm &&
        dataForm.purchase_price_table &&
        dataForm.purchase_price_table.generic_row
    ) {
        const tableIva = dataForm.purchase_price_table.generic_row;

        tableIva.forEach((item) => {
            if (item.name.includes("SIN IVA")) {
                const itemWithIva = tableIva.find(
                    (i) => i.name === item.name.replace("SIN IVA", "CON IVA")
                );

                if (itemWithIva) {
                    let totalWithIva = 0;
                    let totalWithoutIva = 0;
                    months.forEach((month) => {
                        const priceWithIva = parseFloat(item[month]) * ivaRate;
                        change(
                            `purchase_price_table.generic_row[${tableIva.indexOf(
                                itemWithIva
                            )}].${month}`,
                            priceWithIva
                        );
                        totalWithIva += priceWithIva;
                        totalWithoutIva += parseFloat(item[month]);
                    });
                    const averageWithIva = totalWithIva / months.length;
                    const averageWithoutIva = totalWithoutIva / months.length;
                    change(
                        `purchase_price_table.generic_row[${tableIva.indexOf(
                            itemWithIva
                        )}].total`,
                        averageWithIva
                    );
                    change(
                        `purchase_price_table.generic_row[${tableIva.indexOf(
                            item
                        )}].total`,
                        averageWithoutIva
                    );
                }
            }
        });
    }
};

const TableRow = ({ system, index }) => {
    const isDisabled = index === 1 || index === 3;
    const isSpecialRow = index === 0 || index === 2;

    return (
        <React.Fragment key={index}>
            {isSpecialRow && (
                <tr>
                    <td className="titulo-left-padded">
                        {index === 0 ? "LÁTEX" : "SÓLIDOS"}
                    </td>
                    <td colSpan={13}></td>
                </tr>
            )}
            <tr style={{ backgroundColor: "#F0FFC7" }} key={`system-${index}`}>
                <td className="titulo-left-padded" style={{ minWidth: "180px" }}>
                    <Field
                        name={`${system}.name`}
                        component={renderFieldDisabled}
                        className="form-control"
                    />
                </td>
                {months.map((month) => (
                    <td key={month} className="text-right-padded">
                        <Field
                            name={`${system}.${month}`}
                            type="text"
                            component={
                                isDisabled ? renderDollarDisabled : renderDollar
                            }
                            className="form-control"
                            placeholder="$ 0.00"
                            validate={[positiveNumberField]}
                        />
                    </td>
                ))}
                <td className="text-right-padded">
                    <Field
                        name={`${system}.total`}
                        type="text"
                        disabled={true}
                        component={renderDollarDisabled}
                        className="form-control"
                    />
                </td>
            </tr>
        </React.Fragment>
    );
};

const TableSistem = ({ fields }) => (
    <div className="table-responsive">
        <table className="table table-striped table-bordered">
            <thead className="">
                <tr>
                    <th className="titulo-left-padded">SISTEMA</th>
                    {months.map((month, index) => (
                        <th key={month} className="text-right-padded">
                            {index + 1}
                        </th>
                    ))}
                    <th className="text-right-padded">TOTAL</th>
                </tr>
            </thead>
            <tbody>
                {fields.map((system, index) => (
                    <TableRow key={index} system={system} index={index} />
                ))}
            </tbody>
        </table>
    </div>
);

const TablaPrecioCompra = (props) => {
    const { change, dataForm, tab } = props;
    if (tab === "COMPRAS") {
        handleChange(change, dataForm);
    }

    return (
        <div>
            <div className="fn-info mt-4">
                <div className="parametros__fields-row">
                    <div className="parametros__field-wrapper">
                        <label htmlFor="credito5" className="m-0">
                            PRIMA POR PRODUCCIÓN NF
                        </label>
                        <Field
                            name="prima_for_production_nf"
                            component={renderDollar}
                            type="text"
                            className="form-control"
                            validate={[positiveNumberField]}
                        />
                    </div>
                    <div className="parametros__field-wrapper">
                        <label htmlFor="nombre" className="m-0">
                            % DE PRODUCCIÓN NF
                        </label>
                        <Field
                            name="prima_for_production_nf_porcentage"
                            component={renderNumberPercentage}
                            type="text"
                            className="form-control"
                            validate={[positivePercentageField]}
                        />
                    </div>
                </div>
            </div>
            <div className="hr-info">
                <hr />
            </div>
            <span className="fn-info-sb">Precios de fletes y comisiones</span>
            <div className="fn-info">
                <div className="parametros__fields-row">
                    <div className="parametros__field-wrapper">
                        <label htmlFor="credito5" className="m-0">
                            Porcentaje del volumen de látex con fletes
                        </label>
                        <Field
                            name="percentage_of_latex_volume_with_freight"
                            component={renderNumberPercentage}
                            type="text"
                            className="form-control"
                            validate={[positivePercentageField]}
                        />
                    </div>
                    <div className="parametros__field-wrapper">
                        <label htmlFor="nombre" className="m-0">
                            Porcentaje del volumen de sólidos con fletes
                        </label>
                        <Field
                            name="percentage_of_solids_volume_with_freight"
                            component={renderNumberPercentage}
                            type="text"
                            className="form-control"
                            validate={[positivePercentageField]}
                        />
                    </div>
                </div>
            </div>
            <div className="fn-info">
                <div className="parametros__fields-row">
                    <div className="parametros__field-wrapper">
                        <label htmlFor="nombre" className="m-0">
                            Costo /kg flete látex
                        </label>
                        <Field
                            name="cost_per_kg_of_latex_freight"
                            decimalScale={4}
                            component={renderDollar}
                            type="text"
                            className="form-control"
                            validate={[positiveNumberField]}
                        />
                    </div>
                    <div className="parametros__field-wrapper">
                        <label htmlFor="credito5" className="m-0">
                            Costo /kg flete sólidos
                        </label>
                        <Field
                            name="cost_per_kg_of_solid_freight"
                            decimalScale={4}
                            component={renderDollar}
                            type="text"
                            className="form-control"
                            validate={[positiveNumberField]}
                        />
                    </div>
                    <div className="parametros__field-wrapper">
                        <label htmlFor="nombre" className="m-0">
                            Comisiones
                        </label>
                        <Field
                            name="commissions_for_shopping"
                            decimalScale={4}
                            component={renderDollar}
                            type="text"
                            className="form-control"
                            validate={[positiveNumberField]}
                        />
                    </div>
                </div>
            </div>
            <div className="hr-info">
                <hr />
            </div>
            <span className="fn-info-sb">Costo de materia prima</span>
            <div className="fn-info">
                <div className="parametros__fields-row">
                    <div className="parametros__field-wrapper large">
                        <label
                            htmlFor="drc_difference_paid_vs_produced_solids"
                            className="m-0"
                        >
                            Porcentaje de diferencia entre DRC pago vs DRC
                            producción sólido
                        </label>
                        <Field
                            name="drc_difference_paid_vs_produced_solids"
                            component={renderNumberPercentage}
                            type="text"
                            className="form-control"
                            allowNegative
                        />
                    </div>
                    <div className="parametros__field-wrapper large">
                        <label
                            htmlFor="drc_difference_paid_vs_produced_latex"
                            className="m-0"
                        >
                            Porcentaje de diferencia entre DRC pago vs DRC
                            producción látex
                        </label>
                        <Field
                            name="drc_difference_paid_vs_produced_latex"
                            component={renderNumberPercentage}
                            type="text"
                            className="form-control"
                            allowNegative
                        />
                    </div>
                </div>
            </div>

            <div className="hr-info">
                <hr />
            </div>
            <h2 className="titulo_parrafos">V. precios de compra </h2>

            <div className="fn-info m-b-4">
                <FieldArray
                    name="purchase_price_table.generic_row"
                    component={TableSistem}
                />
            </div>
        </div>
    );
};
export default TablaPrecioCompra;
